import { BaseDto } from '@/shared/dtos/base-dto';

export class grupo_usuario extends BaseDto {
    public nombre !: string;
 } 
